function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.178 7.6a4.101 4.177 0 0 1-1.234 2.98 4.302 4.476 0 0 1-2.978 1.233 4.302 4.476 0 0 1-2.98-1.234A3.97 4.131 0 0 1 10.753 7.6a4.099 4.175 0 0 1 1.233-2.979 4.302 4.476 0 0 1 2.978-1.235c1.119 0 2.19.445 2.978 1.235a3.97 4.131 0 0 1 1.236 2.98zm3.16 0a6.946 7.228 0 0 1-2.16 5.214 7.526 7.833 0 0 1-5.213 2.158 7.526 7.833 0 0 1-5.213-2.158A6.946 7.228 0 0 1 7.593 7.6a6.946 7.228 0 0 1 2.159-5.215A7.526 7.833 0 0 1 14.965.227c1.955 0 3.83.776 5.213 2.158A6.946 7.228 0 0 1 22.337 7.6ZM3.378 24.451c0-.43.465-1.705 2.78-3.073 2.146-1.266 5.267-2.192 8.806-2.192 3.538 0 6.66.926 8.804 2.192 2.318 1.37 2.78 2.644 2.78 3.074 0 .557-.222 1.093-.615 1.489a2.15 2.24 0 0 1-1.49.617H5.486a2.126 2.166 0 0 1-1.49-.617 1.985 2.066 0 0 1-.617-1.49Zm11.586-8.426c-8.11 0-14.745 4.213-14.745 8.426a5.124 5.219 0 0 0 1.543 3.725 5.378 5.597 0 0 0 3.721 1.542H24.44a5.378 5.597 0 0 0 3.726-1.544 4.962 5.164 0 0 0 1.542-3.723c0-4.213-6.635-8.426-14.746-8.426z",
    clipRule: "evenodd",
    style: {
      fill: "#fff",
      strokeWidth: 1.84312
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentIcon);
export default __webpack_public_path__ + "static/media/agent-icon.57fdb4d9f0d8a799ed307f8b1518d74d.svg";
export { ForwardRef as ReactComponent };